// ชื่อเว็บไซต์จากชื่อโฮสต์ ใช้ตั้งชื่อไฟล์ส่งออก — ใช้ subdomain ถ้ามี (cdcoreplan.achalee.com → cdcoreplan)
// ถ้าไม่มี subdomain ใช้ชื่อโดเมน (achalee.com → achalee) ตัด www ออก = ป้ายแรกของโฮสต์หลังตัด www
// localhost/IP หรืออ่านไม่ได้ = ''
export const getSiteName = (hostname = window.location.hostname) => {
  const host = String(hostname || '').toLowerCase().replace(/^www\./, '');
  if (!host || host === 'localhost' || /^[\d.:]+$/.test(host)) return '';
  const label = host.split('.')[0];

  return label.replace(/[^a-z0-9_-]/g, '');
};

export default getSiteName;
